const menus = [
  {
    id: 1,
    name: "Home",
    links: "/",
  },
  {
    id: 2,
    name: "Universe",
    links: "/universe",
    namesub: [
      {
        id: 1,
        sub: "Introduction",
        links: "/universe#introduction",
      },
      {
        id: 2,
        sub: "World",
        links: "/universe#world",
      },
      {
        id: 3,
        sub: "Stories",
        links: "/universe#stories",
      },
    ],
  },
  {
    id: 3,
    name: "Game",
    links: "/game",
    namesub: [
      {
        id: 1,
        sub: "Content",
        links: "/game#content",
      },
      {
        id: 2,
        sub: "Gameplay",
        links: "/game#gameplay",
      },
      {
        id: 4,
        sub: "Help",
        links: "/game#help",
      },
      {
        id: 5,
        sub: "Download",
        links: "/game#download",
      },
    ],
  },
  {
    id: 5,
    name: "Companions",
    links: "/deborah",
  },
];

export default menus;
